var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"p-grid"},[_c('td',{staticClass:"p-col"}),_vm._l((_vm.days),function(day){return _c('th',{class:`${_vm.addClass} p-col`},[_c('h2',[_vm._v("\n            "+_vm._s(day.display)+"\n        ")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }